var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-form',{attrs:{"title":"Create Spacer","spacer":"","channel":_vm.channel},on:{"save":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }